import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Img from 'react-image';
import ColorMask from '../ColorMask';
import NavLink from '../NavLink';

const Description = styled.p`
  color: ${props => props.theme.color.textSecondary};
  font-size: 16px;
  font-family: ${props => props.theme.font.sourceSans};
  font-weight: ${props => props.theme.fontWeight.regular};
  line-height: 1.5;
  letter-spacing: -0.26px;
  margin: 4px 0 0 0;
  @media (max-width: ${props => props.theme.deviceWidth.mobilePhone}) {
    line-height: 1.25;
  }
`;

const Image = styled(Img)`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ImageWrapper = styled.div`
  flex: 0 0 auto;
  width: 100px;
  height: 100px;
  overflow: hidden;
  margin-right: 19px;
  position: relative;
  @media (max-width: ${props => props.theme.deviceWidth.mobilePhone}) {
    width: 75px;
    height: 75px;
    margin-right: 10px;
  }
`;

const Title = styled.h2`
  color: ${props => props.theme.color.headerSecondary};
  font-size: 16px;
  font-family: ${props => props.theme.font.sourceSans};
  font-weight: ${props => props.theme.fontWeight.black};
  line-height: 1.5;
  text-transform: uppercase;
  margin: 0;
`;

const Wrapper = styled.div`
  border-bottom: ${props =>
    props.divider && `1px solid ${props.theme.color.borderPrimary}`};
  padding-bottom: ${props => props.divider && '20px'};
  padding-top: 20px;

  & > a {
    display: flex;
  }
`;

const NewsExcerpt = ({
  className,
  description,
  divider,
  id,
  imageUrl,
  title
}) => (
  <Wrapper className={className} divider={divider}>
    <NavLink to={`/news-article/${id}`}>
      <ImageWrapper>
        <ColorMask />
        <Image src={[imageUrl, 'https://placehold.it/100x100']} alt={title} />
      </ImageWrapper>
      <div>
        {title && <Title>{title}</Title>}
        {description && <Description>{description}</Description>}
      </div>
    </NavLink>
  </Wrapper>
);

NewsExcerpt.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string,
  divider: PropTypes.bool,
  id: PropTypes.string,
  imageUrl: PropTypes.string,
  title: PropTypes.string
};

export default NewsExcerpt;
